import { useEffect } from "react";
import { useRecoilState } from "recoil";
import { appSettingAtom } from "../recoil/atoms/appSettingAtom.js";
import { backendGet } from "../services/dataService.js";
import { useSnackbar } from "notistack";

export function useClaimStates() {
  const [appSettings, setAppSettings] = useRecoilState(appSettingAtom);
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    const claimStates = appSettings.claimStates;
    if (!claimStates || !Array.isArray(claimStates.states) || claimStates.states.length === 0) {

      backendGet("/data/schadens/states", {
        label: "Schaden-Status",
        enqueueSnackbar,
        setResult: (res) =>
          setAppSettings((prev) => ({
            ...prev,
            claimStates: res.data,
          })),
      });
    }
  }, [appSettings.claimStates, enqueueSnackbar, setAppSettings]);

  return appSettings.claimStates;
}
